(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PeopleFranchiserFormController', PeopleFranchiserFormController)

    /** @ngInject */
    function PeopleFranchiserFormController($filter, $q, $scope, $rootScope, $state, $stateParams, HelperService, PersonService, AuthenticationService, ApiService, DATA_EVENTS, sweetAlert, ResponsabilityService, AccessLevelService, SYSTEM_MODULES, DEFAULT_IDENTIFIERS) {
        const vm = this;
        const personId = $stateParams.personId;
        let allResponsabilities;
        let allAccessLevels;
        let apiControllers;

        let personOriginalData;
        let customPermissionOriginalData;

        // SYSTEM DEFAULT METHODS
        // vm.uiCanExit = () => {
        //     return HelperService.uiCanExit([
        //         personOriginalData,
        //         customPermissionOriginalData
        //     ], [
        //         vm.personData.Person_Unit,
        //         vm.customPermissions
        //     ]);
        // }

        // vm.isRelationshipDataModified = () => {
        //     return !vm.personData || !angular.equals(vm.personData.Person_Unit, personOriginalData);
        // }

        // vm.resetRelationshipForm = () => {
        //     angular.copy(personOriginalData, vm.personData.Person_Unit);
        // }

        // vm.isCustomPermissionDataModified = () => {
        //     return !angular.equals(vm.customPermissions, customPermissionOriginalData);
        // }

        // vm.resetCustomPermissionForm = () => {
        //     angular.copy(customPermissionOriginalData, vm.customPermissions);
        // }

        // ÁREA CUSTOM METHODS
        // Person Data
        vm.saveUser = () => {
            HelperService.startLoading('.loading-holder');

            let personData = {
                Id: vm.personData.Id,
                Name: vm.personData.Name,
                GenderId: vm.selectedGender.Id,
                Birthdate: HelperService.getMomentDate(vm.personData.BirthdateFormatted).format('YYYY-MM-DD')
            }

            let personDocuments = vm.personData.Person_Document.reduce((acc, cur) => {
                acc.push({
                    DocumentTypeId: cur.DocumentTypeId,
                    Document: cur.Document
                })

                return acc;
            }, []);

            if (!personDocuments.find(x => x.DocumentTypeId == 1)) {
                sweetAlert.swal({
                    title: 'OPS!',
                    text: 'Você também deve informar o CPF da pessoa no cadastro.',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })

                HelperService.stopLoading('.loading-holder');
                return;
            }

            let personEmails = vm.personData.Person_Email.reduce((acc, cur) => {
                acc.push({
                    EmailTypeId: cur.EmailTypeId,
                    Email: {
                        Address: cur.Email.Address
                    }
                })

                return acc;
            }, []);

            let personTelephones = vm.personData.Person_Phone.reduce((acc, cur) => {
                acc.push({
                    PhoneTypeId: cur.PhoneTypeId,
                    Phone: {
                        Code: cur.Phone.Code,
                        Number: cur.Phone.Number
                    }
                })

                return acc;
            }, []);

            personData.Person_Document = personDocuments;
            personData.Person_Email = personEmails;
            personData.Person_Phone = personTelephones;

            PersonService
                .put(personData)
                .then(() => {
                    HelperService.successCallback('update');
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        vm.saveUserAssociations = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação irá alterar a associação da pessoa com as permissões selecionadas!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value)
                    saveUserAssociations(vm.personData.Person_Unit);
            })
        }

        vm.removeAssociation = personUnit => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você irá remover a associação da pessoa com essa loja, ela não poderá mais visualizar os dados!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    let personUnitOriginal = vm.personData.Person_Unit;

                    vm.personData.Person_Unit = vm.personData.Person_Unit.filter(pu => (pu.UnitId != personUnit.UnitId));

                    personUnitOriginal.forEach(pu => {
                        if (pu.Id == personUnit.Id)
                            pu.Active = false;
                    })

                    $scope.$apply();

                    saveUserAssociations(personUnitOriginal);
                }
            })
        }

        vm.onChangePersonUnitAccessLevel = personUnit => {
            // If is franchisee access level
            if (personUnit.AccessLevelId == 3)
                personUnit.ResponsibilityId = 4;
        }

        vm.isLoggedPersonCurrentUnit = unitId => {
            if (vm.loggedUserData.AccessLevelId == 1)
                return true;

            return ($rootScope.canUserEdit || $rootScope.canUserCreate) && (unitId == vm.loggedUserData.UnitId);
        }

        vm.getResponsabilities = personUnit => {
            if (personUnit.AccessLevelId == 3)
                return allResponsabilities.filter(resp => resp.Id == 4);

            return allResponsabilities.filter(resp => resp.Id != 4);
        }

        vm.getAccessLevels = unit => {
            if (!unit.HeadUnitId)
                return allAccessLevels.filter(x => x.Id == 1 || x.Id == 2 || x.Id == 5 || x.Id == 6);

            return allAccessLevels.filter(x => x.Id == 3 || x.Id == 4);
        }

        vm.canEditAccessLevel = personUnit => {
            return vm.loggedUserData.AccessLevelId == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR && !isEditingFranchiseeUnit(personUnit.Unit);
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        // Person Custom Permissions
        vm.savePermissions = () => {
            HelperService.startLoading('.loading-holder');

            let permissionData = vm.customPermissions.filter(perm => (perm.IsGet != null));

            ApiService
                .saveCustomPermissions(permissionData, vm.selectedPersonUnit.Id)
                .then(
                    () => {
                        angular.copy(vm.customPermissions, customPermissionOriginalData);

                        HelperService.stopLoading('.loading-holder');
                        HelperService.successCallback();
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    })
        }

        vm.onChangeSelectedPersonUnit = () => {
            let personCustomPermissions = [];
            let currentPersonCustomPermissions = vm.selectedPersonUnit.ApiController_Person_Unit;

            for (let index = 0; index < apiControllers.length; index++) {
                const apiController = apiControllers[index];

                const currentPersonControllerPermission = currentPersonCustomPermissions.find(perm => (perm.ApiControllerId == apiController.Id));

                if (currentPersonControllerPermission) {
                    currentPersonControllerPermission.ApiController = apiController;
                    currentPersonControllerPermission.IsRecord = currentPersonControllerPermission.IsPost;
                    currentPersonControllerPermission.ChangedByPersonId = vm.loggedUserData.PersonId;

                    personCustomPermissions.push(currentPersonControllerPermission);
                } else {
                    personCustomPermissions.push({
                        ApiControllerId: apiController.Id,
                        Person_UnitId: vm.selectedPersonUnit.Id,
                        ApiController: apiController,
                        IsGet: null,
                        IsPost: null,
                        IsPut: null,
                        IsRecord: null,
                        IsDelete: null,
                        ChangedByPersonId: vm.loggedUserData.PersonId
                    })
                }
            }

            vm.customPermissions = $filter('orderBy')(personCustomPermissions, 'ApiController.Description', false);

            customPermissionOriginalData = angular.copy(vm.customPermissions);
        }

        vm.onChangeRecordPermission = permission => {
            permission.IsPost = permission.IsRecord;
            permission.IsPut = permission.IsRecord;
        }

        vm.isPermissionRequired = customPermission => {
            if (customPermission.IsGet != null || customPermission.IsRecord != null || customPermission.IsDelete != null)
                return true;

            return false;
        }

        vm.onCheckAll = () => {
            for (let index = 0; index < vm.customPermissions.length; index++) {
                const module = vm.customPermissions[index];

                module.IsGet = vm.getAll;
                module.IsRecord = vm.getAll;
                module.IsDelete = vm.getAll;
            }
        }

        init();

        function isEditingFranchiseeUnit(unit) {
            return unit.HeadUnitId && unit.HeadUnitId > 0;
        }

        function saveUserAssociations(personUnitData) {
            HelperService.startLoading('.loading-holder');

            let personUnitFinal = personUnitData
                .filter(personDataUnit => (vm.isLoggedPersonCurrentUnit(personDataUnit.UnitId)))
                .reduce((acc, cur) => {
                    let associationData = {
                        UnitId: cur.UnitId,
                        PersonId: vm.personData.Id,
                        ResponsibilityId: cur.ResponsibilityId,
                        AccessLevelId: cur.AccessLevelId,
                        Active: cur.Active,
                        Id: cur.Id
                    };

                    // If the logged user is an adminstrator let him choose the access level of the found person
                    if (vm.loggedUserData.AccessLevelId == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR) {
                        associationData.AccessLevelId = cur.AccessLevelId;
                    }

                    // If he hasn't set the access level set as franchiser worker by default
                    else {
                        associationData.AccessLevelId = DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER;
                    }

                    acc.push(associationData);

                    return acc;
                }, []);

            PersonService
                .updateUnitAssociation(personUnitFinal)
                .then(() => {
                    angular.copy(vm.personData.Person_Unit, personOriginalData);

                    HelperService.successCallback('update');
                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        function getPerson() {
            if (!personId) {
                sweetAlert.swal({
                    title: 'Não foi possível recuperar os dados da pessoa!',
                    text: 'Ocorreu um erro ao buscar o identificador da pessoa',
                    type: 'warning',
                    confirmButtonText: 'Ir para Home',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        HelperService.stopLoading('.loading-holder');

                        $state.go('app.home');
                    }
                })

                return;
            }

            PersonService
                .get(personId)
                .then(success => {
                    if (success.RegistrationDate)
                        success.RegistrationDateFormatted = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.RegistrationDateFormatted = '-';

                    if (success.Birthdate)
                        success.BirthdateFormatted = moment(success.Birthdate).format('DD/MM/YYYY');
                    else
                        success.BirthdateFormatted = '-';

                    vm.personData = success;

                    if (vm.personData.GenderId)
                        vm.selectedGender = vm.genders.find(gender => (gender.Id == vm.personData.GenderId));

                    if (vm.personData.Person_Image.length) {
                        let personMainImage = vm.personData.Person_Image.find(image => (image.Main));

                        if (personMainImage) {
                            vm.mainImageData.image = personMainImage.Url;
                            vm.mainImageData.display = HelperService.imageResizePath('person', vm.personData.Id, personMainImage.Url, 150, 150);
                        }
                    }

                    personOriginalData = angular.copy(vm.personData.Person_Unit);

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function getGenders() {
            return PersonService
                .getGenders()
                .then(success => {
                    vm.genders = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getResponsabilities() {
            return ResponsabilityService
                .getAll()
                .then(success => allResponsabilities = success,
                    error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.unit-permission-listing');
                    });
        }

        function getAccessLevels() {
            return AccessLevelService
                .getAll()
                .then(success => allAccessLevels = success,
                    error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.custom-filters');
                    });
        }

        function getControllers() {
            return ApiService
                .getControllers()
                .then(success => {
                    apiControllers = $filter('orderBy')(success, 'Id', false);
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function initVars() {
            vm.loggedUserData = AuthenticationService.getSelectedData();

            if (personId == vm.loggedUserData.PersonId) {
                $state.go('app.my-profile');
                return;
            }

            vm.selectedTab = 1;
            vm.selectOptions = [{
                Value: true,
                Description: 'SIM'
            }, {
                Value: false,
                Description: 'NÃO'
            }];
            vm.getAll = null;

            vm.mainImageData = {
                display: '',
                image: ''
            }
        }

        function init() {
            initVars();

            HelperService.startLoading('.loading-holder');

            $q.all([getControllers(), getGenders(), getResponsabilities(), getAccessLevels()])
                .then(() => {
                    getPerson();
                })
        }
    }
}());